import { createSlice } from '@reduxjs/toolkit';

import { RESET_ALL, UPDATE_VIX } from 'constants/enum';
import { Services } from 'services/api/services';
import { vixResponseDecorator } from 'services/decorators/responses';

const initialState = {};

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    setVehicleData: (state, action) => {
      return { ...state, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(RESET_ALL, () => initialState)
      .addMatcher(
        Services.endpoints.checkInsuranceEligibility.matchFulfilled,
        (state, { payload }) => {
          const { vehicleDetails } = vixResponseDecorator(payload);
          return vehicleDetails;
        }
      )
      .addMatcher(
        Services.endpoints.getVehicleInformation.matchFulfilled,
        (state, { payload }) => {
          const { vehicleDetails } = vixResponseDecorator(payload);
          return vehicleDetails;
        }
      );
  }
});

export const { setVehicleData } = vehicleSlice.actions;

export default vehicleSlice.reducer;
